import { Link } from "react-router-dom";
import { Bitcoin, Gem, BarChart3, Coins, Layers, Boxes, ShieldAlert, Scale, Cpu, ArrowLeftRight, Wallet, Flame, TrendingUp, Landmark, CircleDollarSign } from "lucide-react";
import { sectorTrack } from "./SectorHero";

const ICONS: Record<string, any> = {
  bitcoin: Bitcoin, ethereum: Gem, etfs: BarChart3, stablecoins: Coins, defi: Layers,
  "layer-2s": Boxes, security: ShieldAlert, regulation: Scale, "ai-crypto": Cpu,
  exchanges: ArrowLeftRight, wallets: Wallet, solana: Boxes, xrp: CircleDollarSign,
  tether: Coins, binance: ArrowLeftRight, blackrock: Landmark, dogecoin: Coins,
};

export const TrendingStrip = ({ items }: { items: any[] }) => {
  if (!items?.length) return null;
  const chips = items.slice(0, 8);
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-10" data-testid="trending-in-crypto">
      <div className="flex items-baseline justify-between gap-3 mb-4">
        <h2 className="font-heading font-bold text-white text-lg flex items-center gap-2.5">
          <TrendingUp aria-hidden className="h-4.5 w-4.5 h-[18px] w-[18px] text-[#00E5FF]" />
          Trending in Crypto
        </h2>
        <span className="font-mono text-[10px] uppercase tracking-widest text-gray-500"
          title="Topic activity across NewsLayer crypto coverage, last 48 hours">48H window</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {chips.map((t) => {
          const Icon = ICONS[t.topic] || TrendingUp;
          return (
            <Link key={t.topic} to={`/search?q=${encodeURIComponent(t.label)}`}
              data-testid={`trend-tile-${t.topic}`}
              onClick={() => sectorTrack("trending_topic_click", t.topic)}
              className="group flex items-center gap-3 rounded-xl border border-white/[0.08] bg-[#0b0c10] px-4 py-3.5 hover:border-[#00E5FF]/40 transition-colors">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#7C3AED]/[0.14] text-[#A78BFA] group-hover:text-[#00E5FF] transition-colors">
                <Icon aria-hidden className="h-4.5 w-4.5 h-[18px] w-[18px]" />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-1.5">
                  <span className="block font-heading font-bold text-white text-[14.5px] truncate">{t.label}</span>
                  {t.velocity === "up" && (
                    <Flame aria-label="accelerating" className="h-3.5 w-3.5 text-[#F97316]" />
                  )}
                </span>
                <span className="block font-mono text-[10px] text-gray-500 mt-0.5">
                  {t.count} {t.count === 1 ? "story" : "stories"} · 48h
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
